
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomains/[subdomain]/series/[seriesId]",
      function () {
        return require("private-next-pages/_subdomains/[subdomain]/series/[seriesId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomains/[subdomain]/series/[seriesId]"])
      });
    }
  